import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useContract } from '../../../context/ContractContext';
import { HomeIcon, InvestIcon, TeamIcon, ActivityIcon, ProfileIcon, ShieldIcon } from '../../../assets/icons';
import './BottomNav.css';

const navItems = [
  { path: '/dashboard', icon: HomeIcon, label: 'Home' },
  { path: '/invest', icon: InvestIcon, label: 'Invest' },
  { path: '/team', icon: TeamIcon, label: 'Team' },
  { path: '/activity', icon: ActivityIcon, label: 'Activity' },
  { path: '/profile', icon: ProfileIcon, label: 'Profile' }
];

// Only rendered for owner / admin wallets
const adminItem = { path: '/admin', icon: ShieldIcon, label: 'Admin' };

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin } = useContract();

  const items = isAdmin ? [...navItems, adminItem] : navItems;

  return (
    <nav className="bottom-nav">
      {items.map(({ path, icon: Icon, label }) => {
        const isActive = location.pathname === path;
        return (
          <button
            key={path}
            className={`bottom-nav-item ${isActive ? 'active' : ''}`}
            onClick={() => navigate(path)}
          >
            <span className="bottom-nav-icon">
              <Icon size={24} color={isActive ? 'var(--color-primary)' : 'currentColor'} />
            </span>
            <span className="bottom-nav-label">{label}</span>
            {isActive && <span className="bottom-nav-indicator" />}
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
